/**
 * IngestHome — the front door of Ingest: two directions. Faithful port of the
 * locked mockup (mockups/walkthrough/src/components/home/IngestHome.jsx).
 *
 * Opening Ingest forks into:
 *   1. RIGS — the camera arrays (Big Rig / Head Rig). Capture LIVE through
 *      Ingest (arm → fire → manifest → move).
 *   2. HANDHELD EQUIPMENT — everything else (Artec, NimbleTrack, Leica, drone,
 *      XGrids…). These produce their own files; Ingest brings them into a job
 *      AFTER the shoot, with a manifest.
 */
import React from "react";
import "./ingestHome.css";

// rigsOnly: an event account (docs/ops/event-role.md) sees the Rigs card alone.
export default function IngestHome({ onPick, rigsOnly = false }) {
  return (
    <div className="ingest-home-root">
      <div className="ingest-home">
        <div className="ingest-home-cards">
          <button type="button" className="ingest-card" onClick={() => onPick("rigs")}>
            <span className="ingest-card-icon rigs"><RigsIcon /></span>
            <span className="ingest-card-title">Rigs</span>
            <span className="ingest-card-sub">Big Rig · Head Rig</span>
            <span className="ingest-card-tag live">Live capture</span>
          </button>

          {!rigsOnly && <button type="button" className="ingest-card" onClick={() => onPick("handheld")}>
            <span className="ingest-card-icon handheld"><HandheldIcon /></span>
            <span className="ingest-card-title">Handheld equipment</span>
            <span className="ingest-card-sub">Artec · NimbleTrack · Leica · drone · Portal</span>
            <span className="ingest-card-tag after">Ingest after</span>
          </button>}
        </div>
      </div>
    </div>
  );
}

// ── Icons (verbatim from the mockup) ────────────────────────────────────────────
function RigsIcon() {
  // a ring of camera dots around a subject — the array
  const cx = 26, cy = 26, r = 18, dots = [];
  for (let i = 0; i < 14; i++) {
    const a = (i / 14) * Math.PI * 2 - Math.PI / 2;
    dots.push(<circle key={i} cx={cx + r * Math.cos(a)} cy={cy + r * Math.sin(a)} r={2.3} fill="currentColor" />);
  }
  return (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" aria-hidden="true">
      {dots}
      <circle cx={cx} cy={cy} r={5.5} fill="none" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

function HandheldIcon() {
  return (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="13" y="9" width="15" height="20" rx="4" />
      <path d="M18 29 l-2 11 M23 29 l2 11" />
      <path d="M31 15 l9 -3 M31 20 l10 0 M31 25 l9 3" opacity="0.55" />
    </svg>
  );
}
